export class Cards {
    cards = [    {
        id: 1,
        name: 'Registration',
        description: ['UHID generation', 'KYC Upload', 'search parameters', 'Phone validation', 'UHID tagging'],
        is_selected: 0,
        link: 'assets/img/cards/registration.svg',
        parent: {
            setup: [1,5,6],
            bed: [1,2,3,4,5,6],
            department: [1,2,3,4,8,9,12]
        }
    },
    {
        id: 2,
        name: 'Advance Booking',
        description: ['Booking Dashboard', 'Advance payments', 'payments tagging', 'Notification facility'],
        is_selected: 0,
        link: 'assets/img/cards/advance_booking.svg',
        parent: {
            setup: [1,5,6],
            bed: [3,4,5,6],
            department: [1,2,3,8, 9]
        }
    },
    {
        id: 3,
        name: 'Estimate Creation',
        description: ['Estimate dashboard', 'Generate bill', 'estimate date', 'Cash management'],
        is_selected: 0,
        link: 'assets/img/cards/estimate_reation.svg',
        parent: {
            setup: [1,5,6],
            bed: [3,4,5,6],
            department: [1,2,8,9]
        }
    },
    {
        id: 4,
        name: 'OPD Management',
        description: ['OPD Billing', 'Patient 360', 'Service tagging', 'Payment tagging', 'OPD Consultation'],
        is_selected: 0,
        link: 'assets/img/cards/opd.svg',
        parent: {
            setup: [1,5,6],
            bed: [1,2,3,4,5,6],
            department: [1,8]
        }
    },
    {
        id: 5,
        name: 'Doctor Prescription',
        description: ['Token generation', 'prescription history', 'vital management', 'file upload', 'search suggestion', 'digital prescription'],
        is_selected: 0,
        link: 'assets/img/cards/doctor_prescrip.svg',
        parent: {
            setup: [1,6],
            bed: [2,3,4,5,6],
            department: [10]
        }
    },
    {
        id: 6,
        name: 'Appointment Management',
        description: ['Doctor Roster', 'Profile management', 'Appointment Dashboard', 'booking Notification', 'slot exception'],
        is_selected: 0,
        link: 'assets/img/cards/appointment.svg',
        parent: {
            setup: [1,6],
            bed: [2,3,4,5,6],
            department: [10,12]
        }
    },
    {
        id: 7,
        name: 'Queue Management',
        description: ['manage queue', 'queue projection', 'Manual priority patient', 'override facility'],
        is_selected: 0,
        link: 'assets/img/cards/queue.svg',
        parent: {
            setup: [1,6],
            bed: [3,4,5,6],
            department: [10,12]
        }
    },
    {
        id: 8,
        name: 'Day Care Management',
        description: ['Daycare admission', 'Bed allocation', 'Cash billing', 'Discharge workflow', 'print formats'],
        is_selected: 0,
        link: 'assets/img/cards/daycare.svg',
        parent: {
            setup: [1,5,6],
            bed: [3,4,5,6],
            department: [3,8]
        }
    },
    {
        id: 9,
        name: 'Emergency Management',
        description: ['UHID generation', 'panel billing', 'print formats', 'customized templates', 'Visit cancellation '],
        is_selected: 0,
        link: 'assets/img/cards/emergency.svg',
        parent: {
            setup: [1,6],
            bed: [2,3,4,5,6],
            department: [4]
        }
    },
    {
        id: 10,
        name: 'IPD Management',
        description: ['IPD Billing', 'Room allocation', 'Predefined discount', 'Customized IPD', 'Custom Bill'],
        is_selected: 0,
        link: 'assets/img/cards/ipd_management.svg',
        parent: {
            setup: [1,5,6],
            bed: [1,2,3,4,5,6],
            department: [2,8]
        }
    },
    {
        id: 11,
        name: 'IPD Clinical Module',
        description: ['Patient 360', 'Patient History', 'Nursing Notes', 'Doctor Notes', 'Patient Assessment'],
        is_selected: 0,
        link: 'assets/img/cards/ipd_clinical.svg',
        parent: {
            setup: [1,5,6],
            bed: [3,4,5,6],
            department: [8]
        }
    },
    {
        id: 12,
        name: 'Ward Management',
        description: ['Occupancy status', 'Room distribution', 'Patient search', 'Bed category'],
        is_selected: 0,
        link: 'assets/img/cards/ward.svg',
        parent: {
            setup: [1,6],
            bed: [1,2,3,4,5,6],
            department: [2]
        }
    },
    {
        id: 13,
        name: 'Approval Dashboard',
        description: ["Discount Approval", "Refund Approval", "Cash Handover", "search parameter"],
        is_selected: 0,
        link: 'assets/img/cards/approval.svg',
        parent: {
            setup: [1,6],
            bed: [2,3,4,5,6],
            department: [1,2]
        }
    },
    {
        id: 14,
        name: 'Expense Management',
        description: ["Cash Management", "Update category", "voucher creation", "File scanning", "Auto deduct"],
        is_selected: 0,
        link: 'assets/img/cards/expense.svg',
        parent: {
            setup: [1,6],
            bed: [3,4,5,6],
            department: [1,2,3,4,9]
        }
    },
    {
        id: 15,
        name: 'Reports',
        description: ["Bill Report", "Service Report", "Receipt Report", "Cash Report", "EMR Report"],
        is_selected: 0,
        link: 'assets/img/cards/reports.svg',
        parent: {
            setup: [1,6],
            bed: [1,2,3,4,5,6],
            department: [1,2,5]
        }
    },
    {
        id: 16,
        name: 'Claim Management',
        description: ["Claim Dashboard", "claim Settlement", "Multiple Parameter", "Approval Workflow"],
        is_selected: 0,
        link: 'assets/img/cards/claim.svg',
        parent: {
            setup: [1,6],
            bed: [2,3,4,5,6],
            department: [1,11]
        }
    },
    {
        id: 17,
        name: 'MRD Management',
        description: [  "File scanning",  "Enhanced Storage",  "search Parameters",  "Dedicated Reports"],
        is_selected: 0,
        link: 'assets/img/cards/mrd.svg',
        parent: {
            setup: [1,6],
            bed: [1,2,3,4,5,6],
            department: [11]
        }
    },
    {
        id: 18,
        name: 'Settings Dashboard',
        description: ["Staff Management", "Permission Management", "Department Management", "Rate Card Management", "Payout Management"],
        is_selected: 0,
        link: 'assets/img/cards/dashboard_settings.svg',
        parent: {
            setup: [1,6],
            bed: [1,2,3,4,5,6],
            department: [1,2,3,4,11]
        }
    },
    {
        id: 19,
        name: 'Laboratory Management',
        description: ["Lab 360", "Requisition management", "Sample collection", "Reporting workflow", "Report publish"],
        is_selected: 0,
        link: 'assets/img/cards/lab_manage.svg',
        parent: {
            setup: [1,3,5,6],
            bed: [1,2,3,4,5,6],
            department: [6]
        }
    },
    {
        id: 20,
        name: 'Laboratory Report Master',
        description: ["Unit Master", "Method Master", "Storage Master", "Sample Type Master", "Parameter Master"],
        is_selected: 0,
        link: 'assets/img/cards/lab_report.svg',
        parent: {
            setup: [1,3,5,6],
            bed: [1,2,3,4,5,6],
            department: [6]
        }
    },
    {
        id: 21,
        name: 'Laboratory Settings',
        description: ["Print Settings", "Header & Footer", "Pathologist Signature", "QR Code", "Barcode Settings"],
        is_selected: 0,
        link: 'assets/img/cards/lab_setting.svg',
        parent: {
            setup: [1,3,5,6],
            bed: [1,2,3,4,5,6],
            department: [6]
        }
    },
    {
        id: 22,
        name: 'Radiology Management',
        description: [  "Radiology 360",  "Requisition management",  "Reporting workflow",  "PDF report",  "Radiologist validation"],
        is_selected: 0,
        link: 'assets/img/cards/radio_manage.svg',
        parent: {
            setup: [1,4,5,6],
            bed: [1,2,3,4,5,6],
            department: [7]
        }
    },
    {
        id: 23,
        name: 'Radiology Settings',
        description: ["Print Settings", "Report Templates", "Notification Settings", "User Settings"],
        is_selected: 0,
        link: 'assets/img/cards/radio_settings.svg',
        parent: {
            setup: [1,4,5,6],
            bed: [1,2,3,4,5,6],
            department: [7]
        }
    },
    {
        id: 24,
        name: 'Purchase Order',
        description: ["Supplier dashboard", "name creation", "GST mapping", "supplier", "search parameters"],
        is_selected: 0,
        link: 'assets/img/cards/purchase_order.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [2,3,4,5,6],
            department: [5]
        }
    },
    {
        id: 25,
        name: 'Inventory Management',
        description: ["Inventory dashboard", "Generate stock", "reorder workflow", "Product statistics"],
        is_selected: 0,
        link: 'assets/img/cards/inventory.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [1,2,3,4,5,6],
            department: [5]
        }
    },
    {
        id: 26,
        name: 'Return Management',
        description: ["Sale workflow", "Purchase workflow", "Department workflow", "Indent workflow"],
        is_selected: 0,
        link: 'assets/img/cards/return.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [1,2,3,4,5,6],
            department: [5]
        }
    },
    {
        id: 27,
        name: 'Indent Management',
        description: ['indent Dashboard', 'Department workflow', 'Patient workflow', 'stock analysis', 'Patient level stock'],
        is_selected: 0,
        link: 'assets/img/cards/indent.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [1,2,3,4,5,6],
            department: [5]
        }
    },
    {
        id: 28,
        name: 'Pharmacy Reports',
        description: ["Revenue dashboard", "Product report", "Revenue report", "Collection report", "Cash due & Credit", "Purchase report", "Return report"],
        is_selected: 0,
        link: 'assets/img/cards/pharmacy_reports.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [1,2,3,4,5,6],
            department: [5]
        }
    },
    {
        id: 29,
        name: 'Department Allocation',
        description: ["Department dashboard", "MRP feature", "Allocate medicine", "stock view feature"],
        is_selected: 0,
        link: 'assets/img/cards/department.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [1,2,3,4,5,6],
            department: [5]
        }
    },
    {
        id: 30,
        name: 'Dialysis',
        description: ["Department dashboard", "MRP feature", "Allocate medicine", "stock view feature"],
        is_selected: 0,
        link: 'assets/img/cards/dialysis.svg',
        parent: {
            setup: [1,6],
            bed: [],
            department: [9]
        }
    },
    {
        id: 31,
        name: 'Medical Products',
        description: ['Create product', 'medicine category', 'Rack no. facility', 'qty notification', 'medicine mapping', 'Salt mapping'],
        is_selected: 0,
        link: 'assets/img/cards/products.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [],
            department: [5]
        }
    },
    {
        id: 32,
        name: 'Supplier',
        description: ["Supplier dashboard", "name creation", "GST mapping", "supplier", "search parameters"],
        is_selected: 0,
        link: 'assets/img/cards/supplier.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [],
            department: [5]
        }
    },
    {
        id: 33,
        name: 'Purchase',
        description: ["Purchase dashboard", "Purchase creation", "GST inclusive", "GRN"],
        is_selected: 0,
        link: 'assets/img/cards/purchase.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [],
            department: [5]
        }
    },
    {
        id: 34,
        name: 'Retail Dashboard',
        description: ["Retail dashboard", "HIS patient data", "Package billing", "Medicine discount", "patient search"],
        is_selected: 0,
        link: 'assets/img/cards/retail.svg',
        parent: {
            setup: [1,2,5,6],
            bed: [],
            department: [5]
        }
    },
    {
        id: 35,
        name: 'Radiology Reports Master',
        description: ["Radiology Settings", "Reporting workflow", "PDF report", "Radiologist validation"],
        is_selected: 0,
        link: 'assets/img/cards/radio_report_master.svg',
        parent: {
            setup: [1,4,5,6],
            bed: [],
            department: [7]
        }
    },
];
}